import { Grid, Stack, TextField } from '@mui/material';

import Button from '@mui/material/Button';

import { useEffect, useState } from 'react';

import { SubmitHandler, useForm } from 'react-hook-form';

import { useQuery } from 'react-query';

import * as assetApi from '../../api/app/assetApi';

import { ApiError } from '../../components/core/ApiError/ApiError';

import { Loader } from '../../components/core/Loader/Loader';

import { SelectBox } from '../../components/core/SelectBox/SelectBox';

import { useTranslation } from '../../contexts/translation';

import { Asset } from '../../types/app/asset.types';

import {
  assetDashboardTypes,
  DashboardInputs,
  dashboardTypes,
  DashboardTypes,
} from '../../types/app/dashboards.types';

import { dictionary } from '../../utils/core/dictionary';

interface Props {
  onSubmit: SubmitHandler<DashboardInputs>;
  defaultValues?: DashboardInputs;
  onBack: any;
  isEdit?: boolean;
}

export function DashboardForm({ onSubmit, defaultValues, onBack, isEdit }: Props) {
  const { t } = useTranslation();
  const [dashboardType, setDashboardType] = useState<string | null>(
    defaultValues ? defaultValues.type : null,
  );
  const [assetType, setAssetType] = useState<string>(defaultValues?.type || '');

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
  } = useForm<DashboardInputs>();

  const {
    data: assetList,
    isLoading,
    isError,
  } = useQuery<Asset[]>(['assets'], () => assetApi.getAssetList());
  useEffect(() => {
    reset({ ...defaultValues, type: defaultValues?.type ?? '' });
  }, [defaultValues, reset]);

  useEffect(() => {
    if (dashboardType === DashboardTypes.GRAFANA) return;
    setValue('assetType', undefined, { shouldValidate: true });
    setAssetType('');
  }, [dashboardType]);

  if (isError) return <ApiError />;
  if (isLoading || !assetList) return <Loader />;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Name"
              {...register('name', { required: `Dashboard name ${dictionary.IS_REQUIRED}` })}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <SelectBox
              label="Dashboard type"
              items={dashboardTypes}
              valueKey={'code'}
              labelKey={'name'}
              onChange={(event: any) => setDashboardType(event)}
              controllerProps={{
                name: 'type',
                control: control,
                rules: { required: `Dashboard type ${dictionary.IS_REQUIRED}` },
                defaultValue: defaultValues?.type,
              }}
              isRequired
              isReadOnly={isEdit}
              errors={errors}
            />
          </Grid>
          {dashboardType === DashboardTypes.GRAFANA && !defaultValues && (
            <Grid item xs={12}>
              <SelectBox
                label="Grafana dashboard type"
                items={assetDashboardTypes}
                valueKey={'code'}
                labelKey={'name'}
                onChange={(event: any) => setAssetType(event)}
                controllerProps={{
                  name: 'assetType',
                  control: control,
                  rules: { required: `Asset dashboard type ${dictionary.IS_REQUIRED}` },
                }}
                isRequired
                errors={errors}
              />
            </Grid>
          )}
          {(dashboardType === DashboardTypes.EXTERNAL_URL ||
            (dashboardType === DashboardTypes.GRAFANA && defaultValues) ||
            (dashboardType === DashboardTypes.GRAFANA && assetType === 'URL')) && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Url"
                {...register('url')}
                error={Boolean(errors.url)}
                helperText={errors.url?.message}
              />
            </Grid>
          )}
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button type="submit" variant="contained" color="success">
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
